function loadCss(url: string) {
  if (!import.meta.client) {
    return;
  }

  // <link rel="stylesheet" type="text/css" href="styles.css" />
  const tag = document.createElement('link');
  tag.href = url;
  tag.type = 'text/css';
  tag.rel = 'stylesheet';
  const script = document.getElementsByTagName('script')[0];
  if (script) {
    script.parentNode?.insertBefore(tag, script);
  }
}

function loadJs(url: string, attrs: Record<string, any> | null = null, dataAttrs: Record<string, string> | null = null) {
  if (!import.meta.client) {
    return;
  }
  const tag = document.createElement('script');
  tag.defer = true;
  tag.src = url;
  tag.type = 'text/javascript';
  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      // @ts-expect-error this is ok, because it works for functions
      tag[key] = value;
    }
  }
  if (dataAttrs) {
    for (const [key, value] of Object.entries(dataAttrs)) {
      tag.setAttribute(`data-${key}`, value);
    }
  }
  const script = document.getElementsByTagName('script')[0];
  if (script) {
    script.parentNode?.insertBefore(tag, script);
  }
}

function _loadConsentManager() {
  if (!import.meta.client) {
    return;
  }
  loadJs('/assets/js/consentmanager.js', {
    onload: function () {
      initializeVendors();
    },
  });
}

export function loadConsentManager() {
  if (!import.meta.client) {
    return;
  }
  setTimeout(() => {
    _loadConsentManager();
  }, 750);
}

function initializeVendors() {
  if (!import.meta.client) {
    return;
  }

  // @ts-expect-error checkCustomConsents should be defined
  checkCustomConsents({
    s7: 'FACEBOOK',
    s46: 'HOTJAR',
    c53267: 'SNOWPLOW_LOGGED_IN',
    c69235: 'INSIDER',
  });

  // @ts-expect-error checkIabConsents should be defined
  checkIabConsents({
    907: ['AWIN', [1, 7]],
    755: ['GA', [1, 3, 4, 7, 9, 10]],
    42: ['TABOOLA', [1, 2, 3, 4, 5, 6, 7, 8, 10]],
    164: ['OUTBRAIN', [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]],
  });

  // @ts-expect-error __cmp should be defined
  window.__cmp(
    'addEventListener',
    [
      'consent',
      () => {
        setTimeout(() => {
          // @ts-check
          window.__consentIsReady = true;
          // @ts-check
          if (window.onConsentReady !== undefined) {
            // @ts-check
            window.onConsentReady();
          }
        }, 100);
      },
      false,
    ],
    null,
  );
}

export function loadMoli(jsUrl: string, cssUrl: string, isProd: boolean) {
  // @ts-expect-error __doLoadMoli should be defined
  if (window.__doLoadMoli) {
    loadCss(cssUrl);
    loadJs(jsUrl, {
      id: 'moli-ad-tag',
    }, {
      'publisher-code': 'camping',
      'version': isProd ? 'production' : 'staging',
    });
  }
}
